import thunk from 'redux-thunk'
import { createStore, applyMiddleware } from 'redux'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { routerMiddleware } from 'connected-react-router'
import { createBrowserHistory } from 'history'

import api from '../middleware/api.middleware'
import download from '../middleware/download.middleware'
import rootReducer from '../reducers'

export const history = createBrowserHistory()

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['custom']
}

const persistedReducer = persistReducer(persistConfig, rootReducer(history))

const middleware = [
  thunk,
  api,
  download,
  routerMiddleware(history)
]

export default () => {
  const store = createStore(
    persistedReducer,
    applyMiddleware(...middleware)
  )
  const persistor = persistStore(store)
  return { store, persistor }
}
